<!-- 
ConfirmGroupModal.vue
功能：確認加入群組類型視窗
作者：i9400538 陳博承
完成：2021-05-21
-->
<template>
  <div id="confirm-group-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-12 pl-0">
            <h3 v-if="title" class="modal-title">{{title}}</h3>
            <h3 v-else class="modal-title">請選擇編輯群組方式</h3>
          </div>
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
        </div>
        <div style="padding:20px 40px;">
          <div class="row">
            <div style="margin-left:auto; margin-right:0;">
              <button class="btn btn-primary mr-0" @click="$emit('addToCurrentGroup')">加入現有群組</button>
              <button class="btn btn-primary mr-0" @click="$emit('createNewGroup')">成立新的群組</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmGroupModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      dafault: ""
    }
  }
};
</script>
